import React from "react";
import "./Footer.css";
import Wave from "../../img/wave.png";
import Insta from "@iconscout/react-unicons/icons/uil-instagram";
import Fb from "@iconscout/react-unicons/icons/uil-facebook";
import Github from "@iconscout/react-unicons/icons/uil-github";
function Footer() {
  return (
    <div className="footer">
      <img src={Wave} alt="" style={{ width: "100%", height: "15rem" }} />
      <div className="f-content">
        <span>ranjeet16pd@gmail.com</span>
        <div className="f-icons">
          <a href="https://www.instagram.com/ranjeet_r.j_/">
            <Insta color="white" size="3rem" />
          </a>

          <a href="https://www.facebook.com/profile.php?id=100038181072171">
            <Fb color="white" size="3rem" />
          </a>
          <a href="https://github.com/ranjeet16pd">
            <Github color="white" size="3rem" />
          </a>

          <fb />
        </div>
      </div>
    </div>
  );
}

export default Footer;
